import { TabContent } from '../types';
import { isPropertiesForSaleOrRentTab } from './isPropertiesForSaleOrRentTab';

export const allowIndexing = (tabContent: NonNullable<TabContent>) => {
  let allowIndexing = true;
  if (isPropertiesForSaleOrRentTab(tabContent)) {
    if (
      !tabContent.propertyCollection?.properties?.nodes ||
      tabContent.propertyCollection?.properties?.nodes.length <= 5
    ) {
      allowIndexing = false;
    }
  }
  return allowIndexing;
};
